<template>
    <div class="list_item">
        <div class="list_top">
            <div class="friends_user">
                <div class="user_img">
                    <img :src="props.friendvalue?.image" alt="" />
                </div>
                <div class="user_name">
                    <div class="name"> {{ props.friendvalue?.nickname }}</div>
                    <div class="time" v-if="props.friendvalue?.publishtime">{{ props.friendvalue?.publishtime }}</div>
                </div>
            </div>
            <div class="right_box">
                <div class="GameName" v-if="props.friendvalue?.friendRecentlyPlayed" @click="gpgame()">
                    <div> {{ props.friendvalue?.friendRecentlyPlayed.name ? props.friendvalue?.friendRecentlyPlayed.name
                        : 'GameName' }}</div>

                    <div class="icon">
                        <img src="@/assets/Homeimg/righticon.webp" alt="" />
                    </div>
                </div>
                <div class="received" v-if="props.index == '1'">
                    <div class='jieshou' v-if="props.friendvalue?.status == 0">
                        <div class="rbtn  btn" @click="confirm('refuse')">Refuse</div>
                        <div class="abtn btn" @click="confirm('accept')">Accept</div>
                    </div>
                    <div class="shifou" v-else>
                        <div class="text1" v-if="props.friendvalue?.status == 1"> Accepted</div>
                        <div class="text2" v-if="props.friendvalue?.status == 2"> Refused</div>
                    </div>
                </div>
                <div class="sent" v-if="props.index == '2'">
                    <div class="shifou">
                        <div class="text1" v-if="props.friendvalue?.status == 0">To be Confirmed</div>
                        <div class="text2" v-if="props.friendvalue?.status == 1">Accepted</div>
                        <div class="text3" v-if="props.friendvalue?.status == 2"> Refused</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref, defineProps, defineEmits } from 'vue';
import { use_confirm } from '@/request/request.ts'
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
const props = defineProps({
    friendvalue: {
        type: Object,
    },
    index: {
        type: [Number, String]
    }
})
console.log(props.friendvalue, '朋友消息', props.index, '页面index');
const emit = defineEmits(['handleAdd'])
const handleTitle = () => {
    emit("handleAdd", '我是子组件传递的数据')
}
// 关闭抽屉
const dechouti = () => {
    emit("dechouti", '关闭抽屉')
}
//好友消息确认
const confirm = async (index: any) => {
    let data = { event: index, fid: props.friendvalue?.id }
    console.log(data);
    let res = await use_confirm({
        ...data
    })
    if (res.status == 1) {
        console.log(res, '确认成功');
        handleTitle()
    }
}
const gpgame = () => {
    console.log('点击了朋友玩过的游戏', props.friendvalue?.friendRecentlyPlayed.id);
    dechouti()
    router.push(`/GameDetails/${props.friendvalue?.friendRecentlyPlayed.id}`)
}

</script>
<style  lang="less" scoped>
.list_item {
    width: 100%;
    height: 80px;
    background: rgba(0,0,0, 0.2);
    border-radius: 37px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-left: 30px;
    padding-right: 30px;
    margin-top: 20px;

    .list_top {
        width: 100%;
        min-height: 53px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .friends_user {
            min-width: 120px;
            height: 50px;
            display: flex;
            align-items: center;


            justify-content: space-between;
            .user_img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                background: wheat;
                margin-right: 31px;
                overflow: hidden;

                img {
                    width: 50px;
                    height: 50px;
                }
            }

            .user_name {
                min-width: 35px;
                height: 26px;
                font-size: 16px;
                color: white;
                display:flex;
                flex-direction:column;
                // align-items:center;
                .name{
                    width: auto;
                }

                .time {
                    font-size: 13px;
                    font-weight: normal;
                }
            }
        }

        .right_box {
            min-width: 200px;
            height: auto;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .GameName {
                flex-shrink: 0;
                width: 100%;
                font-size: 18px;
                color: white;
                font-size: 16px;
                font-weight:600px;
                display: flex;
                align-items: center;
                justify-content: space-around;

                .icon {
                    width: 14px;
                    height: 25px;
                    flex-shrink: 0;

                    // margin-left: 47px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .received {
                width: 100%;
                display: flex;
                align-items: center;

                .jieshou {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                   
                }

                .shifou {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    font-size: 16px;


                    .text1 {
                        color: #8B80FF;

                    }

                    .text2 {
                        color: #F40000;
                    }

                }

                .btn {
                    width: 108px;
                    height: 40px;
                    border-radius: 27px;
                    box-sizing: border-box;
                    font-size: 16px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: white;
                    font-weight: normal;
                    transition-duration: 0.2s;
                    margin-right:10px
                }

                .btn:active {
                    transform: scale(0.95)
                }

                .rbtn {
                    border: 0.5px solid #F40000;
                }

                .rbtn:hover {
                    background: #F40000;
                }

                .abtn {
                    border: 0.5px solid #8B80FF;
                }

                .abtn:hover {
                    background: #8B80FF;
                }


            }

            .sent {
                width: 100%;
                display: flex;
                align-items: center;
                .shifou {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    font-size: 16px;
                    // text-align:right;
                    .text1 {
                        color: #FFFFFF;
                    }

                    .text2 {
                        color: #8B80FF;
                    }

                    .text3 {
                        color: #F40000;
                    }
                }
            }
        }
    }
}
</style>